import fileDownload from 'js-file-download';
import {ExportTypes} from '../incase-domain/common/exportTypes';
import {IElement} from '../incase-domain/elements';
import {ISlideChangeable} from '../incase-domain/elements/base/slideChangeable';
import {ELEMENT} from '../incase-domain/elements/base/ElementTypes';

const defaultElementProperties = {
    id: '',
    keyIndex: '',
    elementIndex: 0,
    slideId: '',
    elementToClickForDisplay: [],
    elementToDisplayAfterClick: [],
    clearAfterClicked: false,
};

function isSlideChangeable(element: IElement): element is IElement & ISlideChangeable {
    return (element as ISlideChangeable).slideChange !== undefined;
}

export const exportElement = (index: number, elements: IElement[]): void => {
    const element = elements[index] as IElement;

    Object.assign(element, defaultElementProperties);

    if (isSlideChangeable(element)) {
        element.slideChange = {slideId: '', name: ''};
    }

    if (element.type === ELEMENT.YES_NO_QUESTION) {
        element.slideChange = [];
    }

    const exportedElement = {data: element, type: ExportTypes.SLIDE_ELEMENT};
    fileDownload(JSON.stringify(exportedElement), `${element.name.trim().replace(/\s+/g, '_')}.nbl`);
};
